import React from "react";

export const Toggle = ({ isChecked, disabled, onChange }) => {
  const handleClick = () => {
    if (!disabled) {
      onChange({ target: { checked: !isChecked } }); // Toggle the checked state
    }
  };

  return (
    <div
      role="switch"
      aria-checked={isChecked}
      className={`relative flex items-center cursor-pointer rounded-full transition duration-200 p-0.5 h-6 w-11 ${
        disabled ? "cursor-not-allowed bg-gray100" : ""
      } ${isChecked ? "bg-primary500" : "bg-gray100"}`}
      onClick={handleClick}
    >
      <div
        style={{
          transform: `translateX(${isChecked ? 20 : 0}px)`,
          transition: "transform 0.3s ease 0.1s",
        }}
        className="z-10 block aspect-square h-full rounded-full bg-white"
      />
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() => {}}
        className="hidden"
        id="checkbox"
        aria-hidden="true"
      />
    </div>
  );
};
